import request from "@/utils/httpRequest.js"

/**
 */
 export function fetchPageView(params) {
  return request({
    url: 'student',
    method: 'get',
    params
  })
}